<template>
  <v-app>
    <Navbar />
    <v-main class="light-green lighten-5">
      <v-container>
        <router-view />
        <v-btn v-scroll="onScroll" v-show="offsetTop > 500" fab dark fixed bottom right color="primary"
          class="elevation-15" style="margin-bottom: 70px;" @click="$vuetify.goTo(0)">
          <v-icon>mdi-arrow-up-thick</v-icon>
        </v-btn>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
  // @ is an alias to /src
  import Navbar from "./Navbar";
  export default {
    name: "Home",
    components: {
      Navbar,
    },
    data: function () {
      return {
        offsetTop: 0,
      };
    },
    beforeCreate: function () {
      if (!this.$store.state.userInfo) {
        this.$router.push("/login");
      }
    },
    methods: {
      onScroll(e) {
        this.offsetTop = e.target.scrollingElement.scrollTop
      }
    },
  };
</script>